<template>
  <div class="orders-and-couriers-map-component">
    <v-container fluid>
      <loader v-if="isLoading" />

      <div v-else class="couriers-map">
        <div class="orders-map">
          <div class="orders-map-header">
            <v-btn
              class="button button-back"
              color="#F1F3F6"
              @click="$router.back()"
            >
              <font-awesome-icon icon="chevron-left" />
              Вернуться назад
            </v-btn>
            <div class="settings">
              <div class="filial-title">
                Филиал: {{ filialLabel }}
              </div>

              <div v-if="isCustomOrderView">
                Заказ: #{{ customOrder.code }}
              </div>

              <div v-if="isCustomOrderView" class="settings-actions">
                <v-btn
                  color="primary"
                  @click="$router.push('/geo/couriers-map')"
                >
                  Показать все заказы
                </v-btn>
              </div>
              <div v-else class="settings-actions">
                <v-menu
                  offset-y
                  :close-on-content-click="false"
                  class="orders-status-select"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on">
                      <v-icon left>
                        mdi-tune
                      </v-icon>
                      Статусы заказов
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      class="orders-status-select_item"
                      @click="selectAllStatuses"
                    >
                      <label>Все статусы</label>
                      <!--                    <v-checkbox
                        :checked="isAllStatusesChecked"
                        :label="'Все статусы'"
                        @change="selectAllStatuses"
                      />-->
                    </v-list-item>
                    <v-list-item
                      class="status-delimiter orders-status-select_item"
                      @click="selectNotCompletedOrderStatuses"
                    >
                      <label>Не завершенные заказы</label>
                      <!--                    <v-checkbox
                        :value="isNotCompletedStatusesChecked"
                        :label="'Не завершенные заказы'"
                        @change="selectNotCompletedOrderStatuses"
                      />-->
                    </v-list-item>
                    <v-list-item
                      v-for="status in statuses"
                      :key="status.value"
                      class="orders-status-select_item"
                    >
                      <v-switch
                        v-model="checkedStatuses"
                        :label="status.title"
                        color="primary"
                        :value="status.value"
                        :checked="checkedStatuses.includes(status.value)"
                      />

                      <!--                    <v-checkbox
                        v-model="checkedStatuses"
                        :checked="checkedStatuses.includes(status.value)"
                        :value="status.value"
                        :label="status.title"
                      />-->
                    </v-list-item>
                  </v-list>
                </v-menu>

                <div class="courier-toggle-section">
                  <v-switch
                    v-model="showCouriers"
                    label="Показывать курьеров"
                    color="primary"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="orders-map__map">
            <map-block
              :center="mapCenter"
              :zoom="mapZoom"
              :filial="filial"
              :polygons="filteredPolygons"
              :orders="orders"
              :couriers="couriers"
              :loading="isLoading"
              :show-couriers="showCouriers"
            />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import _ from 'lodash'
  import { mapGetters, mapState } from 'vuex'
  import { DateTime } from 'luxon'
  import { websocketService } from '@/services/WebsocketService'
  import MapBlock from '@/components/geo/couriers-map/MapBlock.vue'
  import FilialDataService from '@/services/api/FilialDataService'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'OrdersAndCouriersMap',
    components: {
      MapBlock,
      Loader,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        isLoading: true,
        showCouriers: true,
        statuses: OrderStatus.getVisibleStatusesWithNames(),
        loadTimeout: null,
        checkedStatuses: [],
        customOrder: null,
        customOrderFilialId: null,
        filial: {},
        orders: [],
        couriers: [],
      }
    },
    watch: {
      checkedStatuses () {
        localStorage.setItem(
          'checkedStatuses',
          JSON.stringify(this.checkedStatuses),
        )
        this.updateOrdersBySettings()
      },
      showCouriers () {
        this.updateCouriers()
      },
      isCustomOrderView () {
        this.initMapData()
      },
      ordersFilterDate () {
        this.updateOrdersBySettings()
      },
    },
    computed: {
      ...mapState({
        // couriers: state => state.couriers.currentCouriers,
        ordersFilterDate: (state) => state.orders.ordersFilterDate,
      // orders: state => state.orders.orders,
      }),
      ...mapGetters({
      // filial: 'branches/getGlobalFilial',
      }),
      isCustomFilialView () {
        return !!this.$route.query?.filialId
      },
      isCustomOrderView () {
        return !!this.$route.query?.orderId
      },

      filialId () {
        if (this.isCustomOrderView) {
          return this.customOrderFilialId
        }
        if (this.isCustomFilialView) {
          return this.$route.query?.filialId
        }
        return this.$store.getters['branches/getGlobalFilialId']
      },
      filialLabel () {
        return this.filial ? this.filial.name : 'Филиал не найден'
      },
      mapCenter () {
        return this.filial?.region?.mapCenter
      },
      mapZoom () {
        return this.filial?.region?.mapZoom
      },

      polygons () {
        if (this.$store.getters['polygons/getPolygons']) {
          return this.$store.getters['polygons/getPolygons']
        }
        return []
      },
      filteredPolygons () {
        return this.polygons
      /* .filter(polygon => {
          return polygon.filial.id === this.filial
        }) */
      },
      notCompletedOrderStatuses () {
        return Object.assign(
          [],
          this.statuses
            .map((status) => status.value)
            .filter((status) => !['completed', 'canceled'].includes(status)),
        )
      },
      isAllStatusesChecked () {
        if (!this.checkedStatuses.length) return false
        return this.checkedStatuses.length === this.statuses.length
      },

      isNotCompletedStatusesChecked () {
        if (!this.checkedStatuses.length) return false
        const target = Object.assign([], this.notCompletedOrderStatuses)
        const current = Object.assign([], this.checkedStatuses)

        console.log(
          'isNotCompletedStatusesChecked: ',
          current,
          target,
          _.difference(current, target).length,
          _.difference(target, current).length,
          !_.difference(current, target).length &&
            !_.difference(target, current).length,
        )
        return (
          !_.difference(current, target).length &&
          !_.difference(target, current).length
        )
      },
    },
    methods: {
      selectAllStatuses () {
        if (this.isAllStatusesChecked) {
          this.checkedStatuses = []
        } else {
          this.checkedStatuses = Object.assign(
            [],
            this.statuses.map((status) => status.value),
          )
        }
      },
      selectNotCompletedOrderStatuses () {
        this.checkedStatuses = this.notCompletedOrderStatuses
      },

      updateCouriers: _.debounce(function () {
        this.getCouriers()
      }, 3000),
      updateOrders: _.debounce(function () {
        this.getOrders()
      }, 10000),
      updateOrdersBySettings: _.debounce(function () {
        this.getOrders()
      }, 1000),

      async getCouriers () {
        const params = {
          filialId: this.filialId,
        }

        if (this.isCustomOrderView) {
          params.userId = this.customOrder.courier.id

          if (!params.userId) {
            this.couriers = []
            return
          }
        } else {
          if (!this.showCouriers) {
            this.couriers = []
            return
          }
        }

        this.couriers = await this.$store.dispatch(
          'couriers/getCurrentCouriers',
          params,
        )
      },

      async getCustomOrder () {
        const orderId = this.$route.query?.orderId
        try {
          const response = await this.$store.dispatch(
            'orders/fetchSingleOrders',
            orderId,
          )
          const order = response.data.data
          console.log('custom order', order)
          this.customOrder = order
          this.customOrderFilialId = order.filial.id
          this.filial = order.filial
          this.orders = [order]
        } catch (e) {
          this.showErrorFromResponse()
        }
      },

      getOrders () {
        if (this.isCustomOrderView) {
          return
        }
        const payload = {
          filialId: this.filialId,
          limit: 10000,
          offset: 0,
          page: 1,
          orderStatus: this.checkedStatuses,
          date: this.ordersFilterDate,
        }
        this.$store
          .dispatch('orders/fetchOrdersList', payload)
          .then((response) => {
            this.orders = response.data.items
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
      },
      async loadPolygons () {
        const payload = {
          filialId: this.filialId,
        }
        await this.$store.dispatch('polygons/getPolygonsFromApi', payload)
      },

      loadOrdersAndGeo () {
        this.getOrders()
        this.getCouriers()
      },

      async loadFilial () {
        if (this.$route.query?.filialId) {
          this.filial = await FilialDataService.getOne(this.$route.query.filialId)
          return true
        }
        this.filial = this.$store.getters['branches/getGlobalFilial']
        return true
      },

      initCheckedStatuses () {
        const lsChecked = localStorage.getItem('checkedStatuses')
        if (lsChecked) {
          this.checkedStatuses = Object.assign([], JSON.parse(lsChecked))
        } else {
          this.checkedStatuses = this.notCompletedOrderStatuses
        }
      },
      async initMapData () {
        this.isLoading = true
        this.initCheckedStatuses()

        try {
          if (this.isCustomOrderView) {
            await this.getCustomOrder()
          }
          await this.loadFilial()
          await this.loadPolygons()
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.isLoading = false

        if (!this.isCustomOrderView) {
          this.getOrders()
        }

        this.getCouriers()
      },
    },

    async created () {
      await this.initMapData()
      websocketService.listenEvent(
        `orders.filial.${this.filialId}`,
        'Order\\UpdateOrder',
        this.updateOrders,
      )
      websocketService.listenEvent(
        `couriers.filial.${this.filialId}`,
        'Courier\\UpdateGeo',
        this.updateCouriers,
      )
    },
    beforeDestroy () {
      // Только свои обработчики: без них снимутся все на канале, и в App.vue пропадёт звук нового заказа
      websocketService.stopListening(
        `orders.filial.${this.filialId}`,
        'Order\\UpdateOrder',
        this.updateOrders,
      )
      websocketService.stopListening(
        `couriers.filial.${this.filialId}`,
        'Courier\\UpdateGeo',
        this.updateCouriers,
      )
    },
  }
</script>

<style scoped lang="less">
.orders-and-couriers-map-component {

  .orders-map {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    &-header {
      width: 100%;
      display: flex;

      .button-back {
        margin-right: 20px;
        height: 66px;
        cursor: pointer;
        margin-bottom: 20px;
      }

      .media-sm({
        flex-wrap: wrap;
        .button-back {
          width: 100%;
        }
      });
    }

    .settings {
      width: 100%;
      height: 66px;
      display: flex;
      align-items: center;
      padding: 9px 15px;
      background: #F1F3F6;
      border-radius: 8px;
      margin-bottom: 15px;
      justify-content: space-between;

      &-actions {
        display: flex;
        align-items: center;
      }
      .courier-toggle-section {
        margin-left: 30px;
        ::v-deep {
          .v-messages {
            display: none;
          }
          .v-input--selection-controls {
            margin-top: 0;
          }

          .media-sm({
            label {
              font-size: 13px;
              line-height: 1.2;
            }
          });

        }
      }

      .media-sm({
        flex-wrap: wrap;
        height: auto;
        margin-bottom: 20px;

        .filial-title {
          width: 100%;
          margin-bottom: 10px;
        }
      });

    }

    &__map {
      width: 100%;
      height: 79vh;
    }
  }

  .ymap-container {
    width: 100%;
    height: 79vh;
  }

  .select {
    padding: 10px;
    border: none;
    background: #F1F3F6;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;

    .text-select {
      color: black;
      height: 150%;
      cursor: pointer;
      user-select: none;
      margin: 0;
      line-height: 1;

      &.active {
        svg {
          transform: rotate(0);
        }
      }

      svg {
        width: 12px;
        transform: rotate(180deg);
      }
    }
  }

}

.status-delimiter {
  border-bottom: 1px solid #ccc !important;
}
.orders-status-select_item {

  label {
    color: #696969;
    cursor: pointer;
  }
  .v-input--selection-controls {
    margin-top: 7px;
  }
}
</style>
